/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Facts_Functions_ValueInputs */

const en_gc_resources_facts_functions_value = /** @type {(inputs: Gc_Resources_Facts_Functions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500+`)
};

const zh_gc_resources_facts_functions_value = /** @type {(inputs: Gc_Resources_Facts_Functions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500+`)
};

/**
* | output |
* | --- |
* | "500+" |
*
* @param {Gc_Resources_Facts_Functions_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_facts_functions_value = /** @type {((inputs?: Gc_Resources_Facts_Functions_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Facts_Functions_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_facts_functions_value(inputs)
	return zh_gc_resources_facts_functions_value(inputs)
});
export { gc_resources_facts_functions_value as "gc.resources.facts.functions.value" }